module.exports = __webpack_public_path__ + "static/media/modal_maleta_mobile.08805e45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/product-step/volumetric-options/modal_maleta_mobile.png
// module id = 1587
// module chunks = 0